import Glide from '../../../../Public/Frontend/node_modules/@glidejs/glide';

;(function () {
    let sliders = document.querySelectorAll('.square-teaser--slider .glide');
    if (!sliders.length) {
        return;
    }

    sliders.forEach(el => {
        if (el.querySelectorAll('.glide__slide').length < 2) {
            return;
        }
        new Glide(el, {
            type: 'carousel',
            peek: 0,
            gap: 0,
            rewind: false,
            autoplay: 3000,
            animationDuration: 500
        }).mount();
    });
})();
